import { render, staticRenderFns } from "./SettingsPortfolio.html?vue&type=template&id=d4078606&scoped=true&"
import script from "./SettingsPortfolio.js?vue&type=script&lang=js&"
export * from "./SettingsPortfolio.js?vue&type=script&lang=js&"
import style0 from "./SettingsPortfolio.scss?vue&type=style&index=0&id=d4078606&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4078606",
  null
  
)

export default component.exports